import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { UserList } from '~/features/UserList';
import styles from './styles.module.scss';

/**
 * 利用者 Screen（新UI）
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader variant='title' title='利用者' />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <UserList />
        </Suspense>
      </main>
    </div>
  </div>
);
